import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=75c92b71&scoped=true"
import script from "./bottom-navigation.vue?vue&type=script&lang=js"
export * from "./bottom-navigation.vue?vue&type=script&lang=js"
import style0 from "./bottom-navigation.vue?vue&type=style&index=0&id=75c92b71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c92b71",
  null
  
)

export default component.exports